module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nhnblackpick.ea0f76cfe18ad2e2802e4e79577f5b21.png";